export type HostedFont = {
  weights: Record<string, string>;
  fontFamily: string;
};

const hostedFonts: Record<string, HostedFont> = {
  "Founders Grotesk": {
    weights: {
      "400":
        "https://d3nitvej43d52.cloudfront.net/founders-grotesk-fonts/founders-grotesk-regular.woff2",
      "700":
        "https://d3nitvej43d52.cloudfront.net/founders-grotesk-fonts/founders-grotesk-bold.woff2",
    },
    fontFamily: "Founders Grotesk",
  },
};

export default hostedFonts;